import { useMutation } from "@apollo/client";

import type {
  UpdateLocationInput,
  UpdateLocationMutation,
  UpdateLocationMutationVariables,
} from "../../../../../API";
import { UPDATE_LOCATION } from "../../../../../common/operations/mutations";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useUpdateLocation = () => {
  const [putLocation, { data, loading }] = useMutation<
    UpdateLocationMutation,
    UpdateLocationMutationVariables
  >(UPDATE_LOCATION);

  const updateLocation = async (input: UpdateLocationInput) => {
    return await putLocation({
      variables: {
        input,
      },
      onError: handleApolloError,
    });
  };

  return { updateLocation, data, loading };
};
